import * as apiCommon from '@/api/apiCommon'

// 联系我们
const apiName = '/webapi/base_parameter'

// 获取
export function read(data) {
	return apiCommon.index(apiName + '/read', data)
}

// 获取人才招聘
export function recruitIndex(data) {
	return apiCommon.index('/webapi/recruit/index', data)
}

// 获取人才详情
export function recruitRead(data) {
	return apiCommon.index('/webapi/recruit/read', data)
}

// 人才招聘初始化
export function recruitInit(data) {
	return apiCommon.index('/webapi/recruit/init', data)
}